// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddOrganization_container__Q9NXL {
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 60%;
}

.AddOrganization_header__DoKW7 {
  display: flex;
  justify-content: space-between;
}

.AddOrganization_header__DoKW7 h3 {
  margin: 0;
}

.AddOrganization_header__DoKW7 span {
  cursor: pointer;
}

.AddOrganization_addOrgForm__eMqmZ {
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: #676c7e;
  overflow-y: auto;
}

.AddOrganization_addOrgForm__eMqmZ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.AddOrganization_addOrgForm__eMqmZ {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.AddOrganization_addOrgForm__eMqmZ::-webkit-scrollbar {
  display: none;
}

.AddOrganization_formElement__cnjA0 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 8px 16px;
  flex: 1 1;
}

.AddOrganization_formElement__cnjA0 label {
  font-size: 14px;
  color: rgba(27, 31, 59, 0.65);
}

.AddOrganization_addOrgForm__eMqmZ input,
.AddOrganization_addOrgForm__eMqmZ select {
  border: none;
  background-color: transparent;
  font-size: 1rem;
  color: #121b3f;
}

.AddOrganization_addOrgForm__eMqmZ select:focus,
.AddOrganization_addOrgForm__eMqmZ input:focus {
  outline: none;
}

.AddOrganization_saveBtn__6R36s {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: none;
  background-color: #3082f6;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}

.AddOrganization_saveBtn__6R36s:disabled {
  background-color: #8cb6f1;
  cursor: not-allowed;
}

.AddOrganization_elements__5fJOd {
  display: flex;
  gap: 1rem;
}

.AddOrganization_formElement__cnjA0:has(input:disabled) {
  background-color: rgb(226, 224, 224);
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/addOrganization/AddOrganization.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".container {\n  background-color: white;\n  padding: 32px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: 60%;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.header h3 {\n  margin: 0;\n}\n\n.header span {\n  cursor: pointer;\n}\n\n.addOrgForm {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  color: #676c7e;\n  overflow-y: auto;\n}\n\n.addOrgForm::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.addOrgForm {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.addOrgForm::-webkit-scrollbar {\n  display: none;\n}\n\n.formElement {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border: 1px solid #ededed;\n  border-radius: 12px;\n  padding: 8px 16px;\n  flex: 1;\n}\n\n.formElement label {\n  font-size: 14px;\n  color: rgba(27, 31, 59, 0.65);\n}\n\n.addOrgForm input,\n.addOrgForm select {\n  border: none;\n  background-color: transparent;\n  font-size: 1rem;\n  color: #121b3f;\n}\n\n.addOrgForm select:focus,\n.addOrgForm input:focus {\n  outline: none;\n}\n\n.saveBtn {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0 16px;\n  border: none;\n  background-color: #3082f6;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n\n.saveBtn:disabled {\n  background-color: #8cb6f1;\n  cursor: not-allowed;\n}\n\n.elements {\n  display: flex;\n  gap: 1rem;\n}\n\n.formElement:has(input:disabled) {\n  background-color: rgb(226, 224, 224);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddOrganization_container__Q9NXL`,
	"header": `AddOrganization_header__DoKW7`,
	"addOrgForm": `AddOrganization_addOrgForm__eMqmZ`,
	"formElement": `AddOrganization_formElement__cnjA0`,
	"saveBtn": `AddOrganization_saveBtn__6R36s`,
	"elements": `AddOrganization_elements__5fJOd`
};
export default ___CSS_LOADER_EXPORT___;
